(function ($) {
  function validateLogin() {
    const formLoginAll = '.component-login form';
    const formLoginUser = '[class="component-login"] form';
    const formLoginResetPin = '.component-login.reset-pin form';
    const formLoginResetPinSecurity = '.component-login.reset-pin-security-question form';
    const formLoginForgotPin = '.component-login.forgot-pin form';

    if ($(formLoginAll).length) {
      // Validation - For all login forms
      $(formLoginAll).validate({
        highlight(element, errorClass, validClass) {
          $(element).closest('.form-group').addClass('error');
        },
        unhighlight(element, errorClass, validClass) {
          $(element).closest('.form-group').removeClass('error');
        },
        errorPlacement(error, element) {
          $(element).closest('.form-group').find('input').after(error);
        },
      });

      // Check input values
      $(formLoginAll).find('input').on('keyup', () => {
        const fieldUsername = '#username';
        const fieldPIN = '#pin';
        const fieldSubmit = '[type="submit"]';

        // User Login
        if ($(formLoginUser).length) {
          const checkUsername = $(fieldUsername).val();
          const isNum = /^\d+$/.test(checkUsername);

          $(formLoginUser).find(fieldUsername).attr({ maxlength: '256' });

          if (!isNum && checkUsername.indexOf('@') >= 0 && checkUsername.indexOf('.') >= 0) {
            $(formLoginUser).find(fieldUsername).removeAttr('minlength');
          } else if (parseInt(checkUsername)) {
            if (isNum && checkUsername.length === 9) {
              $(formLoginUser).find(fieldUsername).removeAttr('minlength');
            } else {
              $(formLoginUser).find(fieldUsername).attr({ minlength: '1024' });
            }
          } else {
            $(formLoginUser).find(fieldUsername).attr({ minlength: '1024' });
          }
        }

        // Reset Your Pin
        if ($(formLoginResetPin).length) {
          // Using default validation and equalTo attribute
        }

        // Login - Reset Pin - Security Question
        if ($(formLoginResetPinSecurity).length) {
          // Using default validation
        }

        // Login - Forgot Pin
        if ($(formLoginForgotPin).length) {
          const checkUsername = $(fieldUsername).val();
          const isNum = /^\d+$/.test(checkUsername);

          if (!isNum && checkUsername.indexOf('@') >= 0 && checkUsername.indexOf('.') >= 0) {
            $(formLoginForgotPin).find(fieldUsername).removeAttr('minlength');
          } else if (parseInt(checkUsername)) {
            if (isNum && checkUsername.length === 9) {
              $(formLoginForgotPin).find(fieldUsername).removeAttr('minlength');
            } else {
              $(formLoginForgotPin).find(fieldUsername).attr({ minlength: '1024' });
            }
          } else {
            $(formLoginForgotPin).find(fieldUsername).attr({ minlength: '1024' });
          }
        }

        // Submission - if form is valid, enable submit button
        if ($(formLoginAll).valid() && $(fieldUsername).val() != '' && $(fieldPIN).val() != '') {
          $(formLoginAll).find(fieldSubmit).prop('disabled', false);
        } else {
          $(formLoginAll).find(fieldSubmit).prop('disabled', 'disabled');
        }
      });
    }
  }

  const init = function () {
    validateLogin();
  };

  $(init);
}(jQuery));
